// A2-532 (operator 2026-10-25, the 369-row no-rate card: "options still the
// same?") — a row's tick box for the bar that answers several rows at once.
// A2-582: which answer the bar offers is the server's (GroupAnswers.jsx);
// the hand lists of rate-pick and credit-note flags that lived here are gone.
import React from "react";
import { useTranslation } from "react-i18next";

/** A row's tick box for the bulk bar, on rows whose own control is a decision. */
export const BulkTick = ({ tid, sel, setSel }) => {
  const { t } = useTranslation();
  return (
    <input
      type="checkbox"
      data-testid={`rg-bulkb-check-${tid}`}
      checked={sel.includes(tid)}
      onChange={(e) => setSel((prev) => (e.target.checked ? [...prev, tid] : prev.filter((x) => x !== tid)))}
      aria-label={t("ui.review_grouped.bulk_b_check_aria", { defaultValue: "Select this row for bulk acknowledge" })}
      className="accent-emerald-600"
    />
  );
};
